<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-inspector__inspector">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.realName" placeholder="姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.identity" placeholder="请选择身份" clearable>
            <el-option
              v-for="item in inspectorList"
              :key="item.id"
              :label="item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="schoolId" v-if="$hasPermission('admin:admin:inspector')">
          <el-select v-model="dataForm.schoolId" placeholder="请选择学校" clearable>
            <el-option
               v-for="school in schoolList"
               :value="school.id"
               :label="school.schoolName"
               :key="school.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('inspector:role:config')" type="warning" @click="inspectorRoleConfigHandle()">寝室督导员角色配置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('inspector:inspector:save')" type="primary" @click="addOrUpdateHandle()">寝室学生督导员设置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('inspector:inspector:save')" type="primary" @click="teacherAddOrUpdate()">寝室教师督导员设置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('inspector:inspector:delete')" type="danger" @click="deleteHandle()">批量移除督导员</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="userName" label="用户账号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="realName" label="姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="sex" label="性别" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.sex === sexual.MAN" size="small" type="success">男</el-tag>
            <el-tag v-else-if="scope.row.sex === sexual.WOMAN" size="small" type="success">女</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="identity" label="身份" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.identity === isStudent.STUDENT" size="small" type="success">学生</el-tag>
            <el-tag v-else-if="scope.row.identity === isStudent.TEACHER" size="small" type="danger">老师</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="className" label="班级" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.className == null" size="small" type="danger">无</el-tag>
            <el-tag v-else-if="scope.row.className != null" >{{scope.row.className}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('dormInspector:dormInspector:delete')" type="text" size="small" @click="removeInspector(scope.row)">移除该督导员</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      <teacher-add-or-update v-if="teacherAddOrUpdateVisible" ref="teacherAddOrUpdate" @refreshDataList="getDataList"></teacher-add-or-update>
      <!-- 督导员角色配置 -->
      <inspector-role-config v-if="inspectorRoleConfigVisible" ref="inspectorRoleConfig"></inspector-role-config>
      <!--督导员检查类设置-->
      <inspector-examine-type v-if="inspectorExamineTypeConfigVisible" ref="inspectorExamineType" @refreshDataList="getDataList()"></inspector-examine-type>
      <!--督导员检查年级设置-->
      <inspectorgrade v-if="gradeVisible" ref="inspectorGrade" @refreshDataList="getDataList()"></inspectorgrade>
      <!--申述管理员消息通知-->
      <claim-admin-message v-if="claimAdminMessageVisible" ref="claimAdminMessage" @refreshDataList="getDataList()"></claim-admin-message>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './dorminspector-add-or-update'
import TeacherAddOrUpdate from './teacherdorminspector-add-or-update'
import InspectorRoleConfig from './dorminspector-role-config'
import { isStudent, sexual, inspectorList } from '@/constant'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/dormInspector/dormInspector/page',
        getDataListIsPage: true,
        exportURL: '/dormInspector/dormInspector/export',
        deleteURL: '/dormInspector/dormInspector',
        deleteIsBatch: true
      },
      inspectorList,
      isStudent,
      sexual,
      teacherAddOrUpdateVisible: false,
      inspectorRoleConfigVisible: false,
      inspectorExamineTypeConfigVisible: false,
      claimAdminMessageVisible: false,
      gradeVisible: false,
      schoolList: [],
      dataForm: {
        id: '',
        isInspectorManager: '',
        identity: '',
        realName: '',
        schoolId: ''
      }
    }
  },
  watch: {},
  components: {
    AddOrUpdate,
    TeacherAddOrUpdate,
    InspectorRoleConfig
  },
  methods: {
    // saveAll () {
    //   this.$http.post('inspector/inspectorGrade/saveAll').then(({ data: res }) => {
    //     if (res.code !== 0) {
    //       return this.$message.error(res.msg)
    //     } else {
    //       this.$message({
    //         message: this.$t('prompt.success'),
    //         type: 'success',
    //         duration: 500
    //       })
    //     }
    //   })
    // },
    inspectorRoleConfigHandle () {
      this.inspectorRoleConfigVisible = true
      this.$nextTick(() => {
        this.$refs.inspectorRoleConfig.init()
      })
    },
    init () {
      this.visible = true
      console.log(this.dataForm)
      this.$nextTick(() => {
        this.getDataList()
      })
    },
    teacherAddOrUpdate () {
      this.teacherAddOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.teacherAddOrUpdate.init()
      })
    },
    removeInspector (row) {
      return this.$http.get(`/dormInspector/dormInspector/removeInspector?userId=${row.userId}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.init()
        this.$notify({
          type: 'info',
          duration: '750',
          message: '督导员移除成功',
          onClose: () => {
            this.$emit('refreshDataList')
          }
        })
      })
    },
    changeIsInspectorManager (scope) {
      const params = {
        id: scope.row.id,
        isInspectorManager: scope.row.isInspectorManager
      }
      this.$http.put('/dormInspector/dormInspector', params).then(({ data: res }) => {
        console.log(params)
        if (res.code === 0) {
          this.$notify({
            title: '设置成功',
            type: 'success'
          })
          this.getDataList()
        } else {
          this.$notify({
            title: '未设置成功',
            type: 'error'
          })
        }
      })
    },
    getSchoolList () {
      this.$http.get('school/school/getSchoolList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.schoolList = res.data
        console.log(this.schoolList)
      })
    },
    inspectorExamineTypeConfig (row) {
      this.inspectorExamineTypeConfigVisible = true
      this.$nextTick(() => {
        this.$refs.inspectorExamineType.dataForm.inspectorId = row.id
        this.$refs.inspectorExamineType.dataForm.inspectorName = row.realName
        this.$refs.inspectorExamineType.init()
      })
    },
    claimAdminMessageHandle () {
      this.claimAdminMessageVisible = true
      this.$nextTick(() => {
        this.$refs.claimAdminMessage.init()
      })
    },
    inspectorGradeConfig (row) {
      this.gradeVisible = true
      this.$nextTick(() => {
        this.$refs.inspectorGrade.submitForm.inspectorId = row.id
        this.$refs.inspectorGrade.submitForm.inspectorName = row.realName
        this.$refs.inspectorGrade.init()
      })
    }
  },
  mounted () {
    this.getSchoolList()
  }
}
</script>
